// extracted by mini-css-extract-plugin
export default {"heading":"NoResults_heading__CGaQe","subheading":"NoResults_subheading__7bqP3"};